import apiRequest from "./apiConfig";
import { endpoints, apiVersion } from "./endpoints";

export function registerCrewMemberImageApi(query, payload) {
  return apiRequest({
    url: `${process.env.REACT_APP_NGROK_IMAGE_URL}${apiVersion.version}${endpoints.register}`,
    method: 'post',
    payload,
    query,
    type: 'formData'
  })
}

export function getCrewMemberPhoto(query) {
  return apiRequest({
    url: `${process.env.REACT_APP_NGROK_IMAGE_URL}${apiVersion.version}${endpoints.crewEmployees}${endpoints.photoDetails}`,
    responseType: "arraybuffer",
    query
  })
}

export function deleteCrewMemberPhoto(query) {
  return apiRequest({
    url: `${process.env.REACT_APP_NGROK_IMAGE_URL}${apiVersion.version}${endpoints.crewEmployees}${endpoints.photoDetails}`,
    method: "delete",
    query
  })
}